module.exports = __webpack_public_path__ + "static/media/mobile-commit-main-phone.8deb7bc0.png";